export default {
  loadingWebsites: "Chargement des sites ...",
  website: "Site internet",
  websiteLoading: "Chargement des organismes",
  guide: {
    show: "Voir le guide",
  },
  dataAgreement: {
    title: "Mise à jour des informations relatives au RGPD",
    save: {
      success: "Données sauvegardées avec succès !",
    },
    alert_link: "ici.",
    alert:
      "Dans le cadre des obligations liées au respect de la Norme RGPD, il est nécessaire que vous renseigniez les champs ci-dessous pour que les utilisateurs de votre plateforme puissent vous identifier en tant que responsable de traitement.\n" +
      "Ces données seront utilisées pour compléter la page de gestion de la politique des données de la plateforme que vous pouvez consulter",
  },
};
